"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PresetRuntimePlanSchema = exports.PresetRuntimeContractSchema = exports.PresetRuntimeComponentDefaultSchema = exports.PresetRuntimeComponentPropPolicySchema = exports.PresetRuntimeContentStudioFieldPolicySchema = exports.PresetRuntimeStarterContentPolicySchema = exports.PresetRuntimeDataSourceRequirementSchema = exports.PresetRuntimeGeneratedRouteSchema = exports.PresetStarterContentModeSchema = exports.PresetSeoStrategySchema = exports.PresetEditorSurfaceSchema = exports.PresetDataSourcePurposeSchema = exports.PresetDataSourceLifecycleSchema = void 0;
exports.normalizeRuntimeRoutePath = normalizeRuntimeRoutePath;
exports.getRuntimeRoutePathDepth = getRuntimeRoutePathDepth;
exports.resolvePresetGeneratedRoutePath = resolvePresetGeneratedRoutePath;
exports.getPresetRuntimeContract = getPresetRuntimeContract;
exports.getPresetRuntimeContractForPage = getPresetRuntimeContractForPage;
exports.getPresetRuntimePlan = getPresetRuntimePlan;
exports.getPresetRuntimePlanForPage = getPresetRuntimePlanForPage;
exports.listPresetRuntimeDataSourceRequirements = listPresetRuntimeDataSourceRequirements;
exports.listPresetRuntimeSectionSourceKeys = listPresetRuntimeSectionSourceKeys;
exports.getPresetRuntimeComponentStylePresetId = getPresetRuntimeComponentStylePresetId;
exports.listCustomAppOperationalContentRoles = listCustomAppOperationalContentRoles;
exports.listCustomAppOperationalContentSourceKeys = listCustomAppOperationalContentSourceKeys;
exports.getContentStudioFieldPolicyForRole = getContentStudioFieldPolicyForRole;
exports.getCustomAppContentStudioFieldPolicy = getCustomAppContentStudioFieldPolicy;
const zod_1 = require("zod");
const custom_app_config_1 = require("./custom-app-config");
const page_presets_1 = require("./page-presets");
const standard_custom_app_databases_1 = require("./standard-custom-app-databases");
exports.PresetDataSourceLifecycleSchema = zod_1.z.enum(['core', 'lazy']);
exports.PresetDataSourcePurposeSchema = zod_1.z.enum([
    'page',
    'section',
    'translation',
    'styling',
]);
exports.PresetEditorSurfaceSchema = zod_1.z.enum([
    'wizard',
    'content',
    'translations',
    'design',
    'builder',
    'repair',
]);
exports.PresetSeoStrategySchema = zod_1.z.enum([
    'page-route',
    'content-row',
    'form-route',
    'internal-route',
]);
exports.PresetStarterContentModeSchema = zod_1.z.enum([
    'starter-row',
    'defer-user-content',
    'system-managed',
]);
exports.PresetRuntimeGeneratedRouteSchema = page_presets_1.PagePresetGeneratedChildRouteSchema.extend({
    path: zod_1.z.string().min(1),
    depth: zod_1.z.number().int().nonnegative(),
}).strict();
exports.PresetRuntimeDataSourceRequirementSchema = zod_1.z
    .object({
    sourceKey: zod_1.z.string().min(1),
    role: custom_app_config_1.CustomAppDataSourceRoleSchema,
    contentModel: custom_app_config_1.CustomAppContentModelSchema,
    label: zod_1.z.string().min(1).optional(),
    lifecycle: exports.PresetDataSourceLifecycleSchema,
    purpose: exports.PresetDataSourcePurposeSchema,
})
    .strict();
exports.PresetRuntimeStarterContentPolicySchema = zod_1.z
    .object({
    sourceKey: zod_1.z.string().min(1),
    role: custom_app_config_1.CustomAppDataSourceRoleSchema,
    contentModel: custom_app_config_1.CustomAppContentModelSchema,
    mode: exports.PresetStarterContentModeSchema,
    editableRows: zod_1.z.boolean(),
})
    .strict();
exports.PresetRuntimeContentStudioFieldPolicySchema = zod_1.z
    .object({
    role: custom_app_config_1.CustomAppDataSourceRoleSchema,
    defaultVisibleFields: zod_1.z.array(zod_1.z.string().min(1)),
    advancedFields: zod_1.z.array(zod_1.z.string().min(1)),
    systemFields: zod_1.z.array(zod_1.z.string().min(1)),
})
    .strict();
exports.PresetRuntimeComponentPropPolicySchema = zod_1.z.enum([
    'workflow-form-config',
]);
exports.PresetRuntimeComponentDefaultSchema = zod_1.z
    .object({
    componentType: zod_1.z.string().min(1),
    props: zod_1.z.record(zod_1.z.string(), zod_1.z.unknown()),
    stylePresetId: zod_1.z.string().min(1).nullable(),
    motionSpec: custom_app_config_1.MotionSpecSchema.nullable(),
    propPolicies: zod_1.z.array(exports.PresetRuntimeComponentPropPolicySchema),
})
    .strict();
exports.PresetRuntimeContractSchema = zod_1.z
    .object({
    presetKey: zod_1.z.string().min(1),
    page: zod_1.z
        .object({
        routeKind: custom_app_config_1.RouteKindSchema,
        audience: custom_app_config_1.AudienceSchema,
        templateKey: zod_1.z.string().min(1),
        collectionRole: zod_1.z.string().min(1).nullable(),
        publicationModel: custom_app_config_1.PublicationModelSchema,
    })
        .strict(),
    dataSources: zod_1.z.array(exports.PresetRuntimeDataSourceRequirementSchema),
    components: zod_1.z
        .object({
        sections: zod_1.z.array(page_presets_1.PageSectionPresetSchema),
        allowedComponentTypes: zod_1.z.array(zod_1.z.string().min(1)),
        defaults: zod_1.z.array(exports.PresetRuntimeComponentDefaultSchema),
    })
        .strict(),
    navigation: zod_1.z
        .object({
        enabled: zod_1.z.boolean(),
        sourceKey: zod_1.z.string().min(1).nullable(),
    })
        .strict(),
    listing: zod_1.z
        .object({
        search: zod_1.z.boolean(),
        pagination: zod_1.z.enum(['none', 'load-more', 'pages']),
    })
        .strict(),
    seo: zod_1.z
        .object({
        strategy: exports.PresetSeoStrategySchema,
        robotsIndex: zod_1.z.boolean(),
        manualOverrides: zod_1.z.literal('advanced-only'),
    })
        .strict(),
    operations: zod_1.z
        .object({
        contentStudioRoles: zod_1.z.array(custom_app_config_1.CustomAppDataSourceRoleSchema),
        contentStudioFieldPolicies: zod_1.z.array(exports.PresetRuntimeContentStudioFieldPolicySchema),
        translations: zod_1.z
            .object({
            enabled: zod_1.z.boolean(),
            contentSourceKey: zod_1.z.string().min(1).nullable(),
            translationSourceKey: zod_1.z.string().min(1),
        })
            .strict(),
        customCss: zod_1.z
            .object({
            enabled: zod_1.z.boolean(),
            defaultSurface: zod_1.z.literal('design'),
            advancedSurface: zod_1.z.literal('builder-design'),
        })
            .strict(),
    })
        .strict(),
    health: zod_1.z
        .object({
        requiredSourceKeys: zod_1.z.array(zod_1.z.string().min(1)),
        sectionSourceKeys: zod_1.z.array(zod_1.z.string().min(1)),
    })
        .strict(),
    ux: zod_1.z
        .object({
        defaultVisibleModes: zod_1.z.array(exports.PresetEditorSurfaceSchema),
        advancedModes: zod_1.z.array(exports.PresetEditorSurfaceSchema),
        repairMode: zod_1.z.literal('issue-gated'),
    })
        .strict(),
    generatedChildRoutes: zod_1.z.array(page_presets_1.PagePresetGeneratedChildRouteSchema),
})
    .strict();
exports.PresetRuntimePlanSchema = zod_1.z
    .object({
    presetKey: zod_1.z.string().min(1),
    page: exports.PresetRuntimeContractSchema.shape.page,
    requiredDataSources: zod_1.z.array(exports.PresetRuntimeDataSourceRequirementSchema),
    generatedRoutes: zod_1.z.array(exports.PresetRuntimeGeneratedRouteSchema),
    componentPlan: exports.PresetRuntimeContractSchema.shape.components,
    starterContentPolicy: zod_1.z.array(exports.PresetRuntimeStarterContentPolicySchema),
    contentStudioFieldPolicies: zod_1.z.array(exports.PresetRuntimeContentStudioFieldPolicySchema),
    seoPolicy: exports.PresetRuntimeContractSchema.shape.seo,
    operationalSurfaceRoles: zod_1.z.array(custom_app_config_1.CustomAppDataSourceRoleSchema),
    translationPlan: exports.PresetRuntimeContractSchema.shape.operations.shape.translations,
    healthExpectations: exports.PresetRuntimeContractSchema.shape.health,
    uxPolicy: exports.PresetRuntimeContractSchema.shape.ux,
})
    .strict();
const PAGE_PRESET_DATA_SOURCE_ROLES = new Set(custom_app_config_1.CustomAppDataSourceRoleSchema.options);
const CORE_SITE_DATA_SOURCE_ROLES = new Set(custom_app_config_1.INITIAL_CUSTOM_APP_DATABASE_ROLES);
const CONTENT_STUDIO_ROLE_ORDER = [
    'content',
    'users',
    'topics',
    'clusters',
    'articleBlocks',
    'forms',
];
const CONTENT_STUDIO_ROLE_SET = new Set(CONTENT_STUDIO_ROLE_ORDER);
const CONTENT_STUDIO_DEFAULT_VISIBLE_FIELDS = {
    clusters: ['slug', 'title', 'description', 'status', 'order'],
    topics: ['slug', 'title', 'description', 'status', 'order'],
    content: [
        'slug',
        'title',
        'description',
        'summary',
        'body',
        'image',
        'imageAlt',
        'ctaLabel',
        'ctaUrl',
        'featured',
        'author',
        'readTime',
        'status',
        'publishedAt',
        'scheduledAt',
    ],
    users: [
        'slug',
        'title',
        'role',
        'email',
        'description',
        'avatar',
        'status',
        'order',
    ],
    forms: ['title', 'formConfig', 'submitLabel', 'successMessage', 'status'],
};
const CONTENT_STUDIO_DEFAULT_VISIBLE_FIELDS_BY_CONTENT_MODEL = {
    'legal-page': ['title', 'description', 'body', 'locale', 'status'],
    'knowledge-base-entry': [
        'slug',
        'title',
        'description',
        'summary',
        'blocks',
        'image',
        'imageAlt',
        'featured',
        'author',
        'topic',
        'readTime',
        'status',
        'publishedAt',
        'scheduledAt',
        'locale',
        'hreflangGroup',
    ],
    'intranet-dashboard-item': [
        'title',
        'description',
        'summary',
        'itemType',
        'workStatus',
        'priority',
        'owner',
        'value',
        'target',
        'unit',
        'trend',
        'category',
        'deadline',
        'updatedAt',
        'status',
    ],
};
const CONTENT_STUDIO_SYSTEM_FIELDS = {
    clusters: ['clusterId'],
    topics: ['topicId', 'clusterId'],
    users: ['userId', 'workspaceUserId', 'tenantUserId'],
    content: ['clusterId', 'topicId', 'internalLinkRowIds'],
    forms: ['formKey'],
};
const CONTENT_STUDIO_SYSTEM_FIELDS_BY_CONTENT_MODEL = {
    'legal-page': ['slug', 'updatedAt', 'canonical', 'noindex'],
    'knowledge-base-entry': [
        'body',
        'clusterId',
        'topicId',
        'internalLinkRowIds',
    ],
    'intranet-dashboard-item': [
        'slug',
        'body',
        'image',
        'imageAlt',
        'featured',
        'readTime',
        'publishedAt',
        'scheduledAt',
        'canonical',
        'hreflangGroup',
        'locale',
        'requiredLocale',
        'noindex',
        'clusterId',
        'topicId',
        'internalLinkRowIds',
    ],
};
const SEARCH_ENABLED_ROUTE_KINDS = new Set(['index', 'dashboard']);
const PAGINATED_ROUTE_KINDS = new Set(['index', 'dashboard']);
const CUSTOM_APP_HEADER_DEFAULTS_BY_TEMPLATE = {
    landing: {
        subtitle: 'A focused starting point for your site.',
    },
    'legal-page': {
        title: 'Legal',
        subtitle: 'Legal information for this app.',
    },
    'blog-index': {
        title: 'Journal',
        subtitle: 'Latest updates, articles, and announcements.',
    },
    'blog-post': {
        title: 'Article',
        subtitle: 'Read the full update.',
    },
    'knowledgebase-index': {
        title: 'Knowledge Base',
        subtitle: 'Find guides, categories, and support articles.',
    },
    'knowledgebase-topic': {
        title: 'Topic',
        subtitle: 'Browse related guides and support articles.',
    },
    'knowledgebase-article': {
        title: 'Article',
        subtitle: 'Step-by-step documentation and support content.',
    },
    'intranet-dashboard': {
        title: 'Dashboard',
        subtitle: 'Internal updates, tables, and operational overview.',
    },
    'workflow-form': {
        title: 'Request Form',
        subtitle: 'Collect structured submissions from your audience.',
    },
    custom: {
        title: 'Page',
        subtitle: 'Custom page content.',
    },
};
const CUSTOM_APP_FOOTER_DEFAULTS = {
    showNavigation: true,
};
const DEFAULT_MOTION_BY_COMPONENT_TYPE = {
    'hero-banner': {
        id: 'hero-enter',
        trigger: 'on-enter',
        preset: 'slide-up',
        durationMs: 520,
        delayMs: 0,
        staggerMs: 0,
        easing: 'emphasized',
        reducedMotionPolicy: 'fade',
    },
    'card-grid': {
        id: 'card-grid-enter',
        trigger: 'on-enter',
        preset: 'fade-in',
        durationMs: 360,
        delayMs: 80,
        staggerMs: 60,
        easing: 'standard',
        reducedMotionPolicy: 'fade',
    },
    'knowledge-base-gallery': {
        id: 'kb-gallery-enter',
        trigger: 'on-enter',
        preset: 'fade-in',
        durationMs: 360,
        delayMs: 80,
        staggerMs: 60,
        easing: 'standard',
        reducedMotionPolicy: 'fade',
    },
    'article-list': {
        id: 'list-enter',
        trigger: 'on-enter',
        preset: 'slide-up',
        durationMs: 320,
        delayMs: 60,
        staggerMs: 40,
        easing: 'standard',
        reducedMotionPolicy: 'fade',
    },
    'form-view': {
        id: 'form-enter',
        trigger: 'on-enter',
        preset: 'scale-in',
        durationMs: 260,
        delayMs: 0,
        staggerMs: 0,
        easing: 'ease-out',
        reducedMotionPolicy: 'static',
    },
    'single-article': {
        id: 'article-enter',
        trigger: 'on-enter',
        preset: 'fade-in',
        durationMs: 280,
        delayMs: 0,
        staggerMs: 0,
        easing: 'standard',
        reducedMotionPolicy: 'fade',
    },
};
const KNOWLEDGEBASE_INDEX_COMPONENT_DEFAULTS = {
    'knowledge-base-gallery': {
        articlePathPrefix: '/kb',
        searchPlaceholder: 'Search articles...',
        categoryLabel: 'Categories',
        categoryField: 'topicId',
        featuredField: 'featured',
        featuredLabel: 'Featured article',
        latestLabel: 'Latest & greatest',
        allArticlesLabel: 'All articles',
        latestCount: 2,
        showImage: true,
        showMeta: true,
        showAuthor: true,
    },
};
const LANDING_COMPONENT_DEFAULTS = {
    'custom-app-navigation': {
        visible: true,
    },
    'hero-banner': {
        eyebrow: 'Deine App. Klar aufgebaut.',
        subtitleField: 'description',
        aiHint: 'Gestalte diese Landing Page mit der KI weiter oder füge passende Bereiche hinzu.',
        suggestedSections: [
            'Features',
            'Bento',
            'Carousel',
            'Kennzahlen',
            'Referenzen',
            'FAQ',
            'Call-to-Action',
        ],
    },
    'markdown-renderer': {
        bodyField: 'body',
    },
    'card-grid': {
        teaserSource: 'child-routes',
        gridLabel: 'Entdecke die App',
        showImage: false,
        showTags: false,
    },
    'custom-app-footer': {
        showNavigation: true,
    },
};
const LEGAL_PAGE_COMPONENT_DEFAULTS = {
    'single-article': {
        showBackLink: false,
        showMeta: false,
        renderMarkdown: true,
        preferRuntimeLocale: true,
    },
};
const INTRANET_DASHBOARD_COMPONENT_DEFAULTS = {
    'kpi-card': {
        label: 'Aktive Arbeitsbereiche',
        aggregationType: 'count',
        valueColumn: '',
        format: 'number',
    },
    'bar-chart': {
        groupByColumn: 'workStatus',
        valueColumn: 'value',
        aggregationType: 'count',
        orientation: 'horizontal',
        height: 260,
    },
    'line-chart': {
        xColumn: 'updatedAt',
        yColumns: ['value', 'target'],
        width: 720,
        height: 260,
    },
    'table-view': {
        visibleColumns: [
            'title',
            'workStatus',
            'priority',
            'owner',
            'deadline',
            'value',
            'target',
        ],
        compact: false,
    },
};
const DEFAULT_STYLE_BY_COMPONENT_TYPE = {
    'hero-banner': 'landing-hero',
    'card-grid': 'feature-cards',
    'knowledge-base-gallery': 'feature-cards',
    'article-list': 'blog-cards',
    'single-article': 'kb-cards',
    'form-view': 'forms',
    'kpi-card': 'feature-cards',
    'bar-chart': 'feature-cards',
    'line-chart': 'feature-cards',
    'table-view': 'feature-cards',
};
function isPresetDataSourceRole(value) {
    return PAGE_PRESET_DATA_SOURCE_ROLES.has(value);
}
function createRuntimeDataSourceRequirement(preset, sourceKey, purpose) {
    if (!isPresetDataSourceRole(sourceKey))
        return null;
    const role = sourceKey;
    const contentModel = preset.sourceContentModels[role] ??
        (0, custom_app_config_1.getDefaultCustomAppContentModelForRole)(role);
    const defaultContentModel = (0, custom_app_config_1.getDefaultCustomAppContentModelForRole)(role);
    return {
        sourceKey: (0, custom_app_config_1.createCustomAppDataSourceKey)({ role, contentModel }),
        role,
        contentModel,
        label: createRuntimeDataSourceLabel(preset, contentModel),
        lifecycle: CORE_SITE_DATA_SOURCE_ROLES.has(role) &&
            contentModel === defaultContentModel
            ? 'core'
            : 'lazy',
        purpose,
    };
}
function createRuntimeDataSourceLabel(preset, contentModel) {
    if (contentModel === 'custom-app-user')
        return 'Users';
    if (preset.templateKey.startsWith('knowledgebase')) {
        if (contentModel === 'knowledge-base-entry')
            return 'Knowledge Base Content';
        if (contentModel === 'kb-article-block')
            return 'Article Blocks';
        if (contentModel === 'custom-app-topic')
            return 'Knowledge Base Topics';
        if (contentModel === 'custom-app-cluster')
            return 'Knowledge Base Clusters';
    }
    if (preset.templateKey === 'intranet-dashboard' &&
        contentModel === 'intranet-dashboard-item') {
        return 'Dashboard Work Items';
    }
    return undefined;
}
function deriveRuntimeDataSources(preset) {
    const requirements = [];
    for (const sourceKey of preset.requiredSourceKeys) {
        const requirement = createRuntimeDataSourceRequirement(preset, sourceKey, 'page');
        if (requirement)
            requirements.push(requirement);
    }
    for (const section of preset.defaultSections) {
        for (const sourceKey of section.sourceKeys) {
            const requirement = createRuntimeDataSourceRequirement(preset, sourceKey, 'section');
            if (requirement)
                requirements.push(requirement);
        }
    }
    const seen = new Set();
    return requirements.filter(requirement => {
        const key = `${requirement.role}:${requirement.contentModel}`;
        if (seen.has(key))
            return false;
        seen.add(key);
        return true;
    });
}
function deriveContentStudioRoles(requirements) {
    const roles = new Set(requirements
        .map(requirement => requirement.role)
        .filter(role => CONTENT_STUDIO_ROLE_SET.has(role)));
    return CONTENT_STUDIO_ROLE_ORDER.filter(role => roles.has(role));
}
function listContentStudioFields(role, contentModel) {
    const baseFields = standard_custom_app_databases_1.STANDARD_CUSTOM_APP_DATABASE_COLUMN_DEFS[role].map(def => def.name);
    const relationFields = standard_custom_app_databases_1.STANDARD_CUSTOM_APP_DATABASE_RELATION_DEFS.filter(spec => (0, standard_custom_app_databases_1.standardCustomAppDatabaseRelationAppliesToSource)(spec, {
        role,
        contentModel,
    })).map(spec => spec.sourceName);
    return [...new Set([...baseFields, ...relationFields])];
}
function createContentStudioFieldPolicy(role, contentModel = (0, custom_app_config_1.getDefaultCustomAppContentModelForRole)(role)) {
    if (!CONTENT_STUDIO_ROLE_SET.has(role))
        return null;
    const contentRole = role;
    const allFields = listContentStudioFields(contentRole, contentModel);
    const allFieldSet = new Set(allFields);
    const systemFields = (CONTENT_STUDIO_SYSTEM_FIELDS_BY_CONTENT_MODEL[contentModel] ??
        CONTENT_STUDIO_SYSTEM_FIELDS[contentRole] ??
        []).filter(field => allFieldSet.has(field));
    const defaultVisibleFields = (CONTENT_STUDIO_DEFAULT_VISIBLE_FIELDS_BY_CONTENT_MODEL[contentModel] ??
        CONTENT_STUDIO_DEFAULT_VISIBLE_FIELDS[contentRole] ??
        allFields).filter(field => allFieldSet.has(field));
    const defaultSet = new Set(defaultVisibleFields);
    const systemSet = new Set(systemFields);
    const advancedFields = allFields.filter(field => !defaultSet.has(field) && !systemSet.has(field));
    return exports.PresetRuntimeContentStudioFieldPolicySchema.parse({
        role,
        defaultVisibleFields,
        advancedFields,
        systemFields,
    });
}
function deriveContentStudioFieldPolicies(requirements) {
    return requirements
        .filter(requirement => CONTENT_STUDIO_ROLE_SET.has(requirement.role))
        .map(requirement => createContentStudioFieldPolicy(requirement.role, requirement.contentModel))
        .filter((policy) => policy !== null);
}
function deriveSeoStrategy(preset) {
    if (preset.routeKind === 'detail')
        return 'content-row';
    if (preset.routeKind === 'form')
        return 'form-route';
    if (preset.audience === 'internal')
        return 'internal-route';
    return 'page-route';
}
function deriveComponentDefaultProps(preset, componentType) {
    const props = {};
    if (componentType === 'custom-app-header') {
        Object.assign(props, CUSTOM_APP_HEADER_DEFAULTS_BY_TEMPLATE[preset.templateKey]);
    }
    if (componentType === 'custom-app-footer') {
        Object.assign(props, CUSTOM_APP_FOOTER_DEFAULTS);
    }
    if (preset.templateKey === 'knowledgebase-index') {
        Object.assign(props, KNOWLEDGEBASE_INDEX_COMPONENT_DEFAULTS[componentType]);
    }
    if (preset.templateKey === 'landing') {
        Object.assign(props, LANDING_COMPONENT_DEFAULTS[componentType]);
    }
    if (preset.templateKey === 'legal-page') {
        Object.assign(props, LEGAL_PAGE_COMPONENT_DEFAULTS[componentType]);
    }
    if (preset.templateKey === 'intranet-dashboard') {
        Object.assign(props, INTRANET_DASHBOARD_COMPONENT_DEFAULTS[componentType]);
    }
    return props;
}
function deriveComponentPropPolicies(preset, componentType) {
    return preset.templateKey === 'workflow-form' && componentType === 'form-view'
        ? ['workflow-form-config']
        : [];
}
function deriveComponentDefaults(preset) {
    const componentTypes = new Set([
        'custom-app-header',
        'custom-app-footer',
        ...preset.defaultSections.map(section => section.componentType),
    ]);
    return [...componentTypes].map(componentType => exports.PresetRuntimeComponentDefaultSchema.parse({
        componentType,
        props: deriveComponentDefaultProps(preset, componentType),
        stylePresetId: DEFAULT_STYLE_BY_COMPONENT_TYPE[componentType] ?? null,
        motionSpec: DEFAULT_MOTION_BY_COMPONENT_TYPE[componentType] ?? null,
        propPolicies: deriveComponentPropPolicies(preset, componentType),
    }));
}
function deriveRuntimeContract(preset) {
    const requirements = deriveRuntimeDataSources(preset);
    const sourceKeyByRole = new Map(requirements.map(requirement => [requirement.role, requirement.sourceKey]));
    const sectionSourceKeys = [
        ...new Set(preset.defaultSections.flatMap(section => section.sourceKeys.map(sourceKey => isPresetDataSourceRole(sourceKey)
            ? (sourceKeyByRole.get(sourceKey) ?? sourceKey)
            : sourceKey))),
    ];
    const contentStudioRoles = deriveContentStudioRoles(requirements);
    const contentStudioFieldPolicies = deriveContentStudioFieldPolicies(requirements);
    const contentSource = requirements.find(requirement => requirement.role === 'content') ?? null;
    const navigationSource = requirements.find(requirement => requirement.role === 'navigation') ?? null;
    return exports.PresetRuntimeContractSchema.parse({
        presetKey: preset.presetKey,
        page: {
            routeKind: preset.routeKind,
            audience: preset.audience,
            templateKey: preset.templateKey,
            collectionRole: preset.collectionRole,
            publicationModel: preset.publicationModel,
        },
        dataSources: requirements,
        components: {
            sections: preset.defaultSections,
            allowedComponentTypes: preset.allowedComponentTypes,
            defaults: deriveComponentDefaults(preset),
        },
        navigation: {
            enabled: navigationSource !== null,
            sourceKey: navigationSource?.sourceKey ?? null,
        },
        listing: {
            search: SEARCH_ENABLED_ROUTE_KINDS.has(preset.routeKind),
            pagination: PAGINATED_ROUTE_KINDS.has(preset.routeKind)
                ? 'load-more'
                : 'none',
        },
        seo: {
            strategy: deriveSeoStrategy(preset),
            robotsIndex: preset.audience === 'public',
            manualOverrides: 'advanced-only',
        },
        operations: {
            contentStudioRoles,
            contentStudioFieldPolicies,
            translations: {
                enabled: contentSource !== null,
                contentSourceKey: contentSource?.sourceKey ?? null,
                translationSourceKey: 'translations',
            },
            customCss: {
                enabled: true,
                defaultSurface: 'design',
                advancedSurface: 'builder-design',
            },
        },
        health: {
            requiredSourceKeys: requirements.map(requirement => requirement.sourceKey),
            sectionSourceKeys,
        },
        ux: {
            defaultVisibleModes: ['wizard', 'content', 'translations', 'design'],
            advancedModes: ['builder'],
            repairMode: 'issue-gated',
        },
        generatedChildRoutes: preset.generatedChildRoutes ?? [],
    });
}
function normalizeRuntimeRoutePath(path) {
    const trimmed = path.trim();
    if (!trimmed || trimmed === '/')
        return '/';
    const withLeadingSlash = trimmed.startsWith('/') ? trimmed : `/${trimmed}`;
    return withLeadingSlash.replace(/\/+/g, '/').replace(/\/$/, '') || '/';
}
function getRuntimeRoutePathDepth(path) {
    const normalized = normalizeRuntimeRoutePath(path);
    if (normalized === '/')
        return 0;
    return normalized.split('/').filter(Boolean).length;
}
function resolvePresetGeneratedRoutePath(parentPath, childRoute) {
    const normalizedParentPath = normalizeRuntimeRoutePath(parentPath);
    const normalizedPattern = childRoute.pathPattern.trim();
    if (normalizedPattern.startsWith('/')) {
        return normalizeRuntimeRoutePath(normalizedPattern);
    }
    const suffix = normalizedPattern.replace(/^\/+/, '').replace(/\/+$/, '');
    if (!suffix)
        return normalizedParentPath;
    const prefix = normalizedParentPath === '/' ? '' : normalizedParentPath;
    return normalizeRuntimeRoutePath(`${prefix}/${suffix}`);
}
function deriveStarterContentMode(requirement) {
    if (requirement.role === 'submissions')
        return 'system-managed';
    if (requirement.role === 'content' ||
        requirement.role === 'users' ||
        requirement.role === 'topics' ||
        requirement.role === 'clusters' ||
        requirement.role === 'articleBlocks' ||
        requirement.role === 'forms') {
        return 'starter-row';
    }
    return 'defer-user-content';
}
function deriveStarterContentPolicy(requirements) {
    return requirements.map(requirement => ({
        sourceKey: requirement.sourceKey,
        role: requirement.role,
        contentModel: requirement.contentModel,
        mode: deriveStarterContentMode(requirement),
        editableRows: requirement.role !== 'submissions',
    }));
}
function deriveRuntimePlan(preset, parentPath) {
    const contract = deriveRuntimeContract(preset);
    return exports.PresetRuntimePlanSchema.parse({
        presetKey: contract.presetKey,
        page: contract.page,
        requiredDataSources: contract.dataSources,
        generatedRoutes: contract.generatedChildRoutes.map(childRoute => {
            const path = resolvePresetGeneratedRoutePath(parentPath, childRoute);
            return {
                ...childRoute,
                path,
                depth: getRuntimeRoutePathDepth(path),
            };
        }),
        componentPlan: contract.components,
        starterContentPolicy: deriveStarterContentPolicy(contract.dataSources),
        contentStudioFieldPolicies: contract.operations.contentStudioFieldPolicies,
        seoPolicy: contract.seo,
        operationalSurfaceRoles: contract.operations.contentStudioRoles,
        translationPlan: contract.operations.translations,
        healthExpectations: contract.health,
        uxPolicy: contract.ux,
    });
}
function getPresetRuntimeContract(presetKey) {
    const preset = (0, page_presets_1.getPagePreset)(presetKey);
    return preset ? deriveRuntimeContract(preset) : null;
}
function getPresetRuntimeContractForPage(page) {
    const preset = (0, page_presets_1.getPagePresetForPage)(page);
    return preset ? deriveRuntimeContract(preset) : null;
}
function getPresetRuntimePlan(presetKey, parentPath = '/') {
    const preset = (0, page_presets_1.getPagePreset)(presetKey);
    return preset ? deriveRuntimePlan(preset, parentPath) : null;
}
function getPresetRuntimePlanForPage(page) {
    const preset = (0, page_presets_1.getPagePresetForPage)(page);
    return preset ? deriveRuntimePlan(preset, page.path) : null;
}
function listPresetRuntimeDataSourceRequirements(presetKey) {
    return getPresetRuntimeContract(presetKey)?.dataSources ?? [];
}
function listPresetRuntimeSectionSourceKeys(presetKey) {
    return getPresetRuntimeContract(presetKey)?.health.sectionSourceKeys ?? [];
}
function getPresetRuntimeComponentStylePresetId(componentType) {
    for (const presetKey of Object.keys(page_presets_1.PAGE_PRESETS)) {
        const contract = getPresetRuntimeContract(presetKey);
        const defaultConfig = contract?.components.defaults.find(item => item.componentType === componentType && item.stylePresetId);
        if (defaultConfig?.stylePresetId)
            return defaultConfig.stylePresetId;
    }
    return null;
}
function listCustomAppOperationalContentRoles(customAppConfig) {
    const dataSources = getCustomAppRuntimeDataSources(customAppConfig);
    const roles = new Set();
    for (const key of listCustomAppOperationalContentSourceKeys(customAppConfig)) {
        const source = dataSources[key];
        if (source)
            roles.add(source.role);
    }
    return CONTENT_STUDIO_ROLE_ORDER.filter(role => roles.has(role));
}
function listCustomAppOperationalContentSourceKeys(customAppConfig) {
    const dataSources = getCustomAppRuntimeDataSources(customAppConfig);
    const sourceKeys = new Set();
    for (const page of customAppConfig.pages ?? []) {
        // Configured apps declare their own sources, not a preset's role schema.
        // Keep the page reference authoritative and exclude system-only roles.
        if (page.templateKey === 'custom-app') {
            for (const key of page.dataSourceKeys ?? []) {
                const source = dataSources[key];
                if (source && CONTENT_STUDIO_ROLE_SET.has(source.role)) {
                    sourceKeys.add(key);
                }
            }
            continue;
        }
        const contract = getPresetRuntimeContractForPage(page);
        if (!contract)
            continue;
        const operationalRoles = new Set(contract.operations.contentStudioRoles);
        for (const requirement of contract.dataSources) {
            if (!operationalRoles.has(requirement.role))
                continue;
            if (dataSources[requirement.sourceKey]) {
                sourceKeys.add(requirement.sourceKey);
            }
        }
        for (const sourceKey of page.dataSourceKeys ?? []) {
            const source = dataSources[sourceKey];
            if (!source || !operationalRoles.has(source.role))
                continue;
            sourceKeys.add(sourceKey);
        }
    }
    const hasExplicitCustomAppSources = customAppConfig.pages.some(page => page.templateKey === 'custom-app' &&
        (page.dataSourceKeys?.length ?? 0) > 0);
    if (sourceKeys.size === 0 &&
        !hasExplicitCustomAppSources &&
        dataSources.content) {
        sourceKeys.add('content');
    }
    for (const sourceKey of [...sourceKeys]) {
        const source = dataSources[sourceKey];
        const role = source?.role;
        if (!role || sourceKey === role)
            continue;
        sourceKeys.delete(role);
    }
    return [...sourceKeys].sort((a, b) => {
        const sourceA = dataSources[a];
        const sourceB = dataSources[b];
        const roleA = sourceA?.role ?? 'content';
        const roleB = sourceB?.role ?? 'content';
        const roleOrder = CONTENT_STUDIO_ROLE_ORDER.indexOf(roleA) -
            CONTENT_STUDIO_ROLE_ORDER.indexOf(roleB);
        return roleOrder || a.localeCompare(b);
    });
}
function getContentStudioFieldPolicyForRole(role) {
    return createContentStudioFieldPolicy(role);
}
function getCustomAppRuntimeDataSources(customAppConfig) {
    return (customAppConfig.dataSources ??
        (0, custom_app_config_1.resolveCustomAppBindingDataSources)(customAppConfig));
}
function getCustomAppContentStudioFieldPolicy(customAppConfig, sourceKey) {
    const source = getCustomAppRuntimeDataSources(customAppConfig)[sourceKey];
    if (!source)
        return null;
    const adaptPolicy = (policy) => {
        if (!policy || source.contentModel !== 'knowledge-base-entry') {
            return policy;
        }
        const hasTopicsSource = Object.values(customAppConfig.dataSources).some(candidate => candidate.role === 'topics');
        if (hasTopicsSource || policy.defaultVisibleFields.includes('category')) {
            return policy;
        }
        const insertAt = policy.defaultVisibleFields.indexOf('status');
        const defaultVisibleFields = [...policy.defaultVisibleFields];
        defaultVisibleFields.splice(insertAt < 0 ? defaultVisibleFields.length : insertAt, 0, 'category');
        return {
            ...policy,
            defaultVisibleFields,
            advancedFields: policy.advancedFields.filter(field => field !== 'category'),
        };
    };
    for (const page of customAppConfig.pages ?? []) {
        const contract = getPresetRuntimeContractForPage(page);
        if (!contract)
            continue;
        const sourceBelongsToPage = page.dataSourceKeys.includes(sourceKey) ||
            contract.dataSources.some(requirement => requirement.sourceKey === sourceKey);
        if (!sourceBelongsToPage)
            continue;
        const policy = contract.operations.contentStudioFieldPolicies.find(candidate => candidate.role === source.role) ?? null;
        if (policy)
            return adaptPolicy(policy);
    }
    return adaptPolicy(createContentStudioFieldPolicy(source.role, source.contentModel));
}
